module.exports = __webpack_public_path__ + "static/media/step2_2.04b738c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/step2_2.png
// module id = 763
// module chunks = 0